import axios from '~/utils/axiosInstance';

export const getNotificationResolverRoute = async (notificationId: string) => {
  const response = await axios.get(`/notifications/${notificationId}/resolver`);
  return response.data.url;
};